import { apiFetch, resolveEndpoint } from "./client";

async function resolvePath(preferred, fallback) {
  const found = await resolveEndpoint(preferred);
  return found || fallback;
}

export async function getBillingSummary() {
  const path = await resolvePath(["/billing/summary"], "/billing/summary");
  const { data } = await apiFetch(path, { method: "GET" });
  return data || {};
}

export async function getBillingPlans() {
  const path = await resolvePath(["/billing/plans"], "/billing/plans");
  const { data } = await apiFetch(path, { method: "GET" });
  return data || { plans: [] };
}

export async function createCheckoutSession(plan, interval = "monthly") {
  const path = await resolvePath(["/billing/checkout-session"], "/billing/checkout-session");
  const { data } = await apiFetch(path, { method: "POST", body: { plan, interval } });
  return data || {};
}

export async function createPortalSession() {
  const path = await resolvePath(["/billing/portal-session"], "/billing/portal-session");
  const { data } = await apiFetch(path, { method: "POST" });
  return data || {};
}
